<template>
  <!-- TODO: make accessible -->
  <div class="loading" ref="loading" :class="{ 'text-white': isWhite }">
    <span class="dot">.</span>
    <span class="dot">.</span>
    <span class="dot">.</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    isWhite: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const dots = Array.from(this.$refs.loading.querySelectorAll('.dot')).reverse()
    this.start(dots)
  },
  methods: {
    start(dots) {
      setTimeout(() => {
        const d = dots.pop()
        this.loop(d)
        if (dots.length) this.start(dots)
      }, 200)
    },
    loop(dot) {
      setTimeout(() => {
        dot.classList.toggle('fade')
        this.loop(dot)
      }, 500)
    },
  },
}
</script>

<style scoped lang="postcss">
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  line-height: 2rem;
  span {
    transition: all var(--ani);
  }
  .dot {
    letter-spacing: 10px;
    opacity: 1;
  }
  .fade {
    opacity: 0;
  }
}

.text-white {
  color: white;
}
</style>
